// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/saxonthomas/.openclaw/workspace/thomas-blonde-app/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/Users/saxonthomas/.openclaw/workspace/thomas-blonde-app/app/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;